import { useQuery } from '@tanstack/react-query'
import notificationService from '../../service'
import { notificationQueryKeys } from '../keys/notification.query-keys'

export const useUnreadCount = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: notificationQueryKeys.unreadCount(),
    queryFn: notificationService.getUnreadCount,
    select: (res) => res.object ?? 0,
    enabled,
  })
